module.exports = __webpack_public_path__ + "static/img/p-hx-2.4dffb33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-hx-2.png
// module id = zaYM
// module chunks = 0